import React from 'react';
import { Button } from '../components/ui/button';
import { CheckCircle2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ServicesPage = () => {
  const navigate = useNavigate();
  
  const wealthServices = [
    'Personalized budgeting plans',
    'Strategic spending guidance',
    'Savings system development',
    'Long-term wealth building strategies',
    'Legal support',
    'Income shifting strategies'
  ];

  const insuranceServices = [
    'Life insurance solutions',
    'Short term medical insurance planning',
    'Income protection strategies',
    'Family security planning'
  ];

  const supplementServices = [
    'Accident & Cancer insurance',
    'Vision & Dental coverage',
    'Critical Care & Hospitalization plans',
    'Disability insurance protection'
  ];

  const creditServices = [
    'Credit score improvement strategies',
    'Credit report analysis',
    'Debt management guidance',
    'Financial literacy education'
  ];

  return (
    <div>
      {/* Page Header */}
      <section className="bg-gradient-to-br from-[#D0E8F2] to-[#C4E5F4] py-20 px-6 md:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-serif text-[#0A2540] font-bold mb-6">
            Our Services
          </h1>
          <p className="text-lg md:text-xl text-[#2C3E50] leading-relaxed">
            Comprehensive financial solutions tailored to empower you and your family 
            on the journey to financial freedom and security.
          </p>
        </div>
      </section>
      
      {/* What We Offer Section */}
      <section className="bg-white py-20 px-6 md:px-12">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-serif text-[#0A2540] font-bold text-center mb-16">
            What We Offer
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Wealth Management Details */}
            <div className="bg-gradient-to-br from-[#D0E8F2] to-[#C4E5F4] rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300">
              <h3 className="text-xl font-serif text-[#0A2540] font-bold mb-6">
                Wealth Management
              </h3>
              <ul className="space-y-4 mb-6">
                {wealthServices.map((service, index) => (
                  <li key={index} className="flex items-start space-x-3">
                    <CheckCircle2 className="h-5 w-5 text-[#0B8FD8] flex-shrink-0 mt-1" />
                    <span className="text-sm text-[#2C3E50]">{service}</span>
                  </li>
                ))}
              </ul>
              <Button 
                className="w-full bg-[#0B8FD8] hover:bg-[#0973B0] text-white"
                onClick={() => navigate('/services/wealth-management')}
              >
                Learn More
              </Button>
            </div>

            {/* Insurance Details */}
            <div className="bg-gradient-to-br from-[#D0E8F2] to-[#C4E5F4] rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300">
              <h3 className="text-xl font-serif text-[#0A2540] font-bold mb-6">
                Life & Short Term Medical Insurance
              </h3>
              <ul className="space-y-4 mb-6">
                {insuranceServices.map((service, index) => (
                  <li key={index} className="flex items-start space-x-3">
                    <CheckCircle2 className="h-5 w-5 text-[#0B8FD8] flex-shrink-0 mt-1" />
                    <span className="text-sm text-[#2C3E50]">{service}</span>
                  </li>
                ))}
              </ul>
              <Button 
                className="w-full bg-[#0B8FD8] hover:bg-[#0973B0] text-white"
                onClick={() => navigate('/services/insurance')}
              >
                Learn More
              </Button>
            </div>

            {/* Supplement Plans Details */}
            <div className="bg-gradient-to-br from-[#D0E8F2] to-[#C4E5F4] rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300">
              <h3 className="text-xl font-serif text-[#0A2540] font-bold mb-6">
                Healthcare Supplement Plans
              </h3>
              <ul className="space-y-4 mb-6">
                {supplementServices.map((service, index) => (
                  <li key={index} className="flex items-start space-x-3">
                    <CheckCircle2 className="h-5 w-5 text-[#0B8FD8] flex-shrink-0 mt-1" />
                    <span className="text-sm text-[#2C3E50]">{service}</span>
                  </li>
                ))}
              </ul>
              <Button 
                className="w-full bg-[#0B8FD8] hover:bg-[#0973B0] text-white"
                onClick={() => navigate('/services/supplement-plans')}
              >
                Learn More
              </Button>
            </div>

            {/* Credit Education Details */}
            <div className="bg-gradient-to-br from-[#D0E8F2] to-[#C4E5F4] rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300">
              <h3 className="text-xl font-serif text-[#0A2540] font-bold mb-6">
                Credit Education
              </h3>
              <ul className="space-y-4 mb-6">
                {creditServices.map((service, index) => (
                  <li key={index} className="flex items-start space-x-3">
                    <CheckCircle2 className="h-5 w-5 text-[#0B8FD8] flex-shrink-0 mt-1" />
                    <span className="text-sm text-[#2C3E50]">{service}</span>
                  </li>
                ))}
              </ul>
              <Button 
                className="w-full bg-[#0B8FD8] hover:bg-[#0973B0] text-white"
                onClick={() => navigate('/services/credit-education')}
              >
                Learn More
              </Button>
            </div>
          </div>

          <div className="text-center mt-12">
            <Button 
              className="bg-[#0B8FD8] hover:bg-[#0973B0] text-white px-8 py-3 text-base rounded-md transition-all duration-300 shadow-lg hover:shadow-xl"
              onClick={() => window.open('https://go.sbrooksassociatesllc.com/bookwithshannon', '_blank')}
            >
              Schedule a Free Consultation
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
